import React, {Component} from 'react';
import {client} from '../../Client';
import { Button, Form, Input, Message, Checkbox } from 'semantic-ui-react'
import Moment from 'moment';
import {convertNullToEmptyString, arrayToCombo} from '../../Helpers'
import ErrorMessage from '../ErrorMessage'
import {Redirect} from 'react-router-dom';
import 'moment/locale/it.js';
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import PropTypes from 'prop-types';

class NewsForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: this.props.match.params.id, // Se undefined siamo in insert, altr in update
            inUpdate: this.props.match.params.id !== undefined,
            fields: this.getEmptyFields(),
            fieldErrors: {},
            fieldErrorsText: [],
            inError: false,
            _loading: false,
            errorTitle: '',
            saveSuccess: false,
            cancelSuccess: false,
            error: null,
            itemSaved: null,
            dropdownCommesseLoading: false,
            commesseList: [],
            dropdownGareLoading: false,
            gareList: [],
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleCancel = this.handleCancel.bind(this)
        this.formIsValid = this.formIsValid.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onInputChangeUppercase = this.onInputChangeUppercase.bind(this)
        this.onInputCheckboxChange = this.onInputCheckboxChange.bind(this)
        this.isLoadingInProgress = this.isLoadingInProgress.bind(this)
        this.comboCommesseLoaded = this.comboCommesseLoaded.bind(this)
        this.comboCommesseLoadedError = this.comboCommesseLoadedError.bind(this)
        this.comboGareLoaded = this.comboGareLoaded.bind(this)
        this.comboGareLoadedError = this.comboGareLoadedError.bind(this)

    }

    isLoadingInProgress(){
        return this.state._loading;
    }
    componentDidMount() {
        if (this.state.inUpdate)
        {
            this.setState({ _loading: true });
            client.loadNews(this.state.id).then(
                (response) => {
                    if (response.ok){
                        response.json().then((news) => {
                            
                            let fields = convertNullToEmptyString(news);

                            // Aggiunge in fondo al testo la data di oggi
                            let ora = Moment().format("dddd DD/MM/YYYY HH:mm");
                            let user = client.getCurrentUser().username;
                            fields.testo = fields.testo + "\n\n" + ora + " - " + user + " - ";

                            fields.idCommessa = fields.idCommessa === undefined ? null : fields.idCommessa.idCommessa;
                            fields.idGara = fields.idGara === undefined ? null : fields.idGara.idGara;
                            this.setState({ _loading: false, fields: fields,  fieldErrors: {},
                                fieldErrorsText: [], inError: false, error: null, itemSaved: news});
                            this.comboCommesse();
                            this.comboGare();
                            this.forceUpdate();
                        })
                    }
                    else if (response.status === 401)
                    {
                        this.props.history.push("/login")
                    }
                    else
                    {
                        response.json().then((errore) => {
                            let fieldErrorsText = []
                            let fieldErrors = {}
                            this.setState({
                                _loading: false,
                                fieldErrors: fieldErrors,
                                fieldErrorsText: fieldErrorsText,
                                errorTitle: '',
                                error: {title: errore.title, msg: errore.msg},
                                inError: true
                            });
                        });

                    }
            }).catch((error) => {

                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    _loading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: "Errore di rete imprevisto", msg: error.message},
                    inError: true
                });

            });
        }
        else{
            this.comboCommesse();
            this.comboGare();
        }
    }

    comboCommesseLoaded(response){

        if (response.ok)
        {
            response.json().then((data)=>{
                this.setState({
                    dropdownCommesseLoading: false,
                    error: null,
                    commesseList: arrayToCombo(data.items, "idCommessa", "nomeCompleto", "idCommessa")
                })
            })
        }
        else if (response.status === 401)
        {
            this.props.history.push("/login")
        }            else
        {
            response.json().then((errore) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownCommesseLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: errore.title, msg: errore.msg},
                    inError: true
                });
            });
        }
    }

    comboCommesseLoadedError(error){
        let fieldErrorsText = []
        let fieldErrors = {}
        this.setState({
            dropdownCommesseLoading: false,
            fieldErrors: fieldErrors,
            fieldErrorsText: fieldErrorsText,
            errorTitle: '',
            error: {title: "Errore di rete imprevisto", msg: error.message},
            inError: true
        });
    }

    comboCommesse(){
        this.setState({ dropdownCommesseLoading: true });
        if(this.state.inUpdate){
            client.loadCommesseTutteList().then(this.comboCommesseLoaded).catch(this.comboCommesseLoadedError);
        }
        else{
            client.loadCommesseNonArchiviateList().then(this.comboCommesseLoaded).catch(this.comboCommesseLoadedError);
        }
    }

    comboGareLoaded(response){

        if (response.ok)
        {
            response.json().then((data)=>{
                this.setState({
                    dropdownGareLoading: false,
                    error: null,
                    gareList: arrayToCombo(data.items, "idGara", "nomeCompleto", "idGara")
                })
            })
        }
        else if (response.status === 401)
        {
            this.props.history.push("/login")
        }            else
        {
            response.json().then((errore) => {
                let fieldErrorsText = []
                let fieldErrors = {}
                this.setState({
                    dropdownGareLoading: false,
                    fieldErrors: fieldErrors,
                    fieldErrorsText: fieldErrorsText,
                    errorTitle: '',
                    error: {title: errore.title, msg: errore.msg},
                    inError: true
                });
            });
        }
    }

    comboGareLoadedError(error){
        let fieldErrorsText = []
        let fieldErrors = {}
        this.setState({
            dropdownGareLoading: false,
            fieldErrors: fieldErrors,
            fieldErrorsText: fieldErrorsText,
            errorTitle: '',
            error: {title: "Errore di rete imprevisto", msg: error.message},
            inError: true
        });
    }

    comboGare(){
        this.setState({ dropdownGareLoading: true });
        if(this.state.inUpdate){
            client.loadGareTutteList().then(this.comboGareLoaded).catch(this.comboGareLoadedError);
        }
        else{
            client.loadGareTutteList().then(this.comboGareLoaded).catch(this.comboGareLoadedError);
        }
    }

    getEmptyFields() {
        let ora = Moment().format("YYYY-MM-DD");
        return {
            'titolo': '',
            'testo': '',
            'dataPubblicazione': ora,
            'archiviata' : false,
            'idGara' : undefined,
            'idCommessa' : undefined,
        }
    }

    formIsValid(formData) {
        // Validazione dati
        let fieldErrorsText = []
        let fieldErrors = {}

        if (formData.titolo.trim() === "")
        {
            fieldErrors["titolo"] = true;
            fieldErrorsText.push("Titolo della Notizia: devi fornire un titolo non vuoto. Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: '-', ' '.");
        }
    
        if (formData.titolo !== "")
        {
            if ( (/^[\w\- ]+$/.test(formData.nome)) === false ){
                fieldErrors["nome"] = true;
                fieldErrorsText.push("Nome della News: Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: '-', ' '.");
            }
        }
        // Validazione date
        if (formData.dataPubblicazione === "Invalid date"){
            fieldErrors["dataPubblicazione"] = true;
            fieldErrorsText.push("La data di pubblicazione non è nel formato corretto (gg/mm/aaaa)");
        }

        if (Object.keys(fieldErrors).length > 0)
        {
            this.setState({
                fieldErrors: fieldErrors,
                fieldErrorsText: fieldErrorsText,
                errorTitle:"La form contiene errori",
                inError: true
            })
            return false;
        }
        return true;
    }

    handleCancel(e) {
        e.preventDefault();
        this.setState({cancelSuccess: true})
    }

    handleSubmit(e) {
        e.preventDefault();
        let formData = this.state.fields;

        // Validazione form
        if (!this.formIsValid(formData)){
            return;
        }

        // Salvataggio sul server
        delete formData["stato-search"];
        this.setState({_loading: true});
        client.saveNews(
            formData,
            this.state.fields.idNews,
        ).then((response) => {
            if (response.ok){
                response.json().then((data) => {
                    let fields = this.state.fields;
                    fields["idNews"] = data.idNews;
                    this.setState({
                        _loading: false,
                        inError: false,
                        fieldErrors: {},
                        fieldErrorsText: [],
                        saveSuccess: true,
                        successTitle: "Salvataggio news",
                        successText: "La notizia è stata salvata correttamente",
                        fields: fields,
                        itemSaved: data,
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((error) => {
                    let fieldErrorsText = []
                    let fieldErrors = {}

                    if (error.errors !== undefined){
                        Object.keys(error.errors).map((item) => {
                            fieldErrors[item] = true;
                            fieldErrorsText = fieldErrorsText.concat(item + ":" +error.errors[item]);
                            return 0;
                        });
                    }
                    else {
                        fieldErrorsText = [error.message]
                    }
                    this.setState({
                        _loading: false,
                        fieldErrors: fieldErrors,
                        fieldErrorsText: fieldErrorsText,
                        errorTitle:error.title,
                        inError: true
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                fieldErrors: {},
                fieldErrorsText: [error.message],
                errorTitle: "Errore di rete imprevisto",
                inError: true
            });
        });
    }

    onInputChange(a1, {name, value}){

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields });
        }
    }

    onInputCheckboxChange(a1, {name, checked}){
        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = checked;
            this.setState({ fields });
        }
    }

    onInputChangeUppercase(a1, {name, value}){
        if (name !== undefined)
        {
            const fields = this.state.fields;

            fields[name] = value.toUpperCase();

            this.setState({ fields });
        }
    }

    render() {
        
        let btnSalva = null;
        if (client.getCurrentUser().isrolenewsw){
            btnSalva = <div className="left aligned eight wide column">
                <Button primary type='submit' loading={this.isLoadingInProgress()}><i className="save icon"/> Salva</Button>
            </div>
        }else{
            btnSalva = <div className="left aligned eight wide column">
                <Button secondary disabled type='submit'><i className="save icon"/>Non hai i diritti per salvare</Button>
            </div>
        }

        if (this.state.error != null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} />)
        }

        let formInError = this.state.fieldErrorsText.length > 0;

        if (this.state.saveSuccess || this.state.cancelSuccess){

            return <Redirect to={ {
                pathname: '/app/news/list',
                state: {
                    from: this.props.location,
                    item: this.state.itemSaved
                },
            }}/>
        }
        let titleMsg = this.state.inUpdate ?
            <h3 className="ui block attached top header"><i className="edit icon"></i> Modifica Notizia - Informazioni di base</h3>
            :
            <h3 className="ui block attached top header"><i className="add square icon"></i> Nuova Notizia - Informazioni di base</h3>

        return (
            <div>
            <Form onSubmit={this.handleSubmit} error={formInError} loading={this.state._loading} success={this.state.saveSuccess}>

                {titleMsg}
                <div className="ui attached segment">
                <Form.Group widths="3">
                    <Form.Field width={12} label="Titolo" required={true} control={Input} name='titolo' autoComplete="nope"  placeholder='Titolo della notizia' maxLength="250"  value={this.state.fields.titolo}  onChange={this.onInputChange}/>
                    <Form.Field width={3}>
                        <label>Data pubblicazione</label>
                        <DatePickerInput
                            onChange={(jsDate, dateString) => {this.onInputChange(null, {name: 'dataPubblicazione', value: dateString === "Invalid date"?"":dateString})}}
                            value={this.state.fields.dataPubblicazione}
                        />
                    </Form.Field>
                    <Form.Field width={1} >
                        <label>Archiviata</label>
                        <Checkbox name="archiviata" defaultIndeterminate={false} toggle checked={this.state.fields.archiviata} onChange={this.onInputCheckboxChange} />
                    </Form.Field>
                </Form.Group>
                    <em >Titolo: Utilizzare solo caratteri alfanumerici e i caratteri speciali seguenti: meno (-) blank ( )</em>
                <Form.TextArea name='testo' label='Testo' placeholder='' rows='30' value={this.state.fields.testo} onChange={this.onInputChange}/>
                

{/*                 <Form.Group widths='1'>
                    <Form.Dropdown width={16} loading={this.state.dropdownCommesseLoading} placeholder='Commessa associata a questa notizia' name='idCommessa' fluid search selection options={this.state.commesseList} value={this.state.fields.idCommessa}
                                onChange={this.onInputChange} error={this.state.fieldErrors["idCommessa"]} />                    
                </Form.Group>
                <Form.Group widths='1'>
                    <Form.Dropdown width={16} loading={this.state.dropdownGareLoading} placeholder='Gara associata a questa notizia' name='idGara' fluid search selection options={this.state.gareList} value={this.state.fields.idGara}
                                onChange={this.onInputChange} error={this.state.fieldErrors["idGara"]} />    
                </Form.Group>
 */}
                </div>
                <Message
                    error
                    header={this.state.errorTitle}
                    list={this.state.fieldErrorsText}
                />
                <Message
                    success
                    header={this.state.successTitle}
                    content={this.state.successText}
                    icon={"smile"}
                />

                <p></p>
                <div className="ui grid">
                    <div className="right aligned eight wide column">
                        <a onClick={this.handleCancel} className="ui right floated  secondary  button"><i className="undo icon"/>Annulla</a>
                    </div>
                    {btnSalva}
                </div>

            </Form>
            </div>
        )
    }
}

NewsForm.contextTypes = {
    router: PropTypes.object
}

export default NewsForm;




/** WEBPACK FOOTER **
 ** ./src/components/news/NewsForm.js
 **/